import {useEffect, useState} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faMinus, faPlus, faTrash} from '@fortawesome/free-solid-svg-icons';
import {connect, useSelector} from 'react-redux';
import {Empty, Spin} from 'antd';
import BasketInfo from './BasketInfo';
import {reduxStore} from '../../../../services/redux/ReduxIndex';
import {setBasketList} from '../../../../services/redux/actions/BasketAction';
import _ from "lodash";
import HelperGeneral from "../../../../helpers/HelperGeneral";
import {Col, Container, Row} from "react-bootstrap";
import Api from "../../../../services/Api";
import UserInfo from "../../../auth/UserInfo";

const BasketList = (props) => {
    const {basketList} = reduxStore.getState().BasketReducer;
    const currentBasketList = useSelector(state => state.BasketReducer.basketList);
    const [basketEdit, setBasketEdit] = useState(!props?.basketView);
    const [loading, setLoading] = useState(false);

    const increment = (itemId, quantity) => {
        HelperGeneral.alert("Aylık hediye ürün sipariş limiti 1 olduğu için ürün adeti arttırılamamaktadır.")
        // setLoading(true);
        // const newQuantity = ++quantity;
        //
        // addBasket(itemId, newQuantity);
    }

    const decrement = (itemId, quantity) => {
        setLoading(true);
        const newQuantity = quantity > 0 ? --quantity : 0;

        addBasket(itemId, newQuantity);
    }

    const removeBasketItem = (itemId) => {
        setLoading(true);

        addBasket(itemId, 0);
    }

    const addBasket = (itemId, quantity) => {
        const data = {
            product_id: itemId,
            quantity: quantity,
            type: 1,
            uniqid: Api.uuidv4(),
            gift_product: 1
        };

        Api.addBasket(data).then((res) => {
            Api.getBasket().then((response) => {
                if (response?.data.products?.length > 0) {
                    localStorage.setItem("basketList", JSON.stringify(response.data));
                    setBasketList(response.data);
                } else {
                    localStorage.removeItem("basketList");
                    setBasketList([]);
                }
                setLoading(false);
            }).catch((e) => {
                HelperGeneral.alert(e);
                setLoading(false);
            });
        });
    }

    useEffect(() => {
        setLoading(true)
        Api.getBasket().then((response) => {
            if (response?.data?.warningArray?.length > 0) {
                HelperGeneral.alert(response?.data?.warningArray[0])
            }

            if (response?.data.products?.length > 0) {
                localStorage.setItem("basketList", JSON.stringify(response.data));
                setBasketList(response.data);
            } else {
                localStorage.removeItem("basketList");
                setBasketList([]);
            }
            setLoading(false);
        }).catch((e) => {
            HelperGeneral.alert(e);
            setLoading(false);
        });
    }, [])

    return (
        <>
            <ul className={'mt-3 mb-3 basket-list w-100 h-100'}>
                <Spin spinning={loading} className={'w-100 h-100'}>
                    {
                        (currentBasketList && currentBasketList?.products && currentBasketList?.products?.length > 0) && currentBasketList?.products?.map((v, i) => (
                            <li key={i}>
                                <Container>
                                    <Row>
                                        <Col xs={3} className={'image-col'}>
                                            <Link to={'/product/' + v?.product_id} onClick={() => props.handleClose()}>
                                                <img src={v?.image} className={"img-thumbnail"}/>
                                            </Link>
                                        </Col>
                                        <Col xs={9} className={'info-col'}>
                                            <Row>
                                                <Col xs={9} className={'title-col'}>
                                                    <Link to={'/product/' + v?.product_id} onClick={() => props.handleClose()}>
                                                        <span>{v?.name}</span>
                                                    </Link>
                                                </Col>
                                                {
                                                    basketEdit && (
                                                        <Col xs={3} className={'d-flex align-items-start justify-content-end'}>
                                                            <FontAwesomeIcon
                                                                icon={faTrash}
                                                                style={{cursor: 'pointer', borderRadius: '4px'}}
                                                                onClick={() => {
                                                                    removeBasketItem(v?.product_id)
                                                                }}
                                                                className={'quantity-input__modifier quantity-input__modifier--right'}
                                                            />
                                                        </Col>
                                                    )
                                                }
                                            </Row>
                                            <Row>
                                                <Col xs={true}>
                                                    {
                                                        basketEdit ? (
                                                            <div className={"quantity-input"}>
                                                                <button
                                                                    type={"button"}
                                                                    className={"quantity-input__modifier quantity-input__modifier--left"}
                                                                    onClick={() => decrement(v?.product_id, v?.quantity)}
                                                                >
                                                                    <FontAwesomeIcon icon={faMinus} size={'sm'}/>
                                                                </button>
                                                                <input
                                                                    className={"quantity-input__screen"}
                                                                    type={"text"}
                                                                    value={v?.quantity}
                                                                    readOnly={true}
                                                                />
                                                                <button
                                                                    type={"button"}
                                                                    className={"quantity-input__modifier quantity-input__modifier--right"}
                                                                    onClick={() => increment(v?.product_id, v?.quantity)}
                                                                >
                                                                    <FontAwesomeIcon icon={faPlus} size={'sm'}/>
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <span>{v?.quantity} adet x {parseInt(v?.gift_point, 10)} puan</span>
                                                        )
                                                    }
                                                </Col>
                                                <Col xs={'auto'} className={'d-flex align-items-center justify-content-end'}>
                                                    {basketEdit ? parseInt(v?.gift_point, 10) : parseInt((v?.gift_point * v?.quantity), 10)} puan
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Container>
                            </li>
                        ))
                    }
                </Spin>
            </ul>
            {/*{*/}
            {/*    !basketEdit && (*/}
            {/*        <>*/}
            {/*            <Row>*/}
            {/*                <Col xs={8} className={'d-flex align-items-center justify-content-start'}>*/}
            {/*                    Toplam Harcanacak Puan*/}
            {/*                </Col>*/}
            {/*                <Col xs={4} className={'d-flex align-items-center justify-content-end'}>*/}
            {/*                    {totalPoint} puan*/}
            {/*                </Col>*/}
            {/*            </Row>*/}
            {/*            <hr/>*/}
            {/*            <Row>*/}
            {/*                <Col xs={7}>*/}
            {/*                    <Row>*/}
            {/*                        <Col xs={12}>Toplam ödenecek tutar</Col>*/}
            {/*                        <Col*/}
            {/*                            xs={12}*/}
            {/*                            style={{*/}
            {/*                                fontSize: 14,*/}
            {/*                                color: '#fbbda0',*/}
            {/*                            }}*/}
            {/*                        >*/}
            {/*                            (KDV dahil)*/}
            {/*                        </Col>*/}
            {/*                    </Row>*/}
            {/*                </Col>*/}
            {/*                <Col xs={5} className={'d-flex align-items-center justify-content-end'}>*/}
            {/*                    <h2>*/}
            {/*                        {props?.price ? HelperGeneral.formatMoneyTL(props?.price) : '-'}*/}
            {/*                    </h2>*/}
            {/*                </Col>*/}
            {/*            </Row>*/}
            {/*        </>*/}
            {/*    )*/}
            {/*}*/}
            {
                currentBasketList?.products?.length < 1 && (
                    <Empty className={'mt-3'} description={'Sepetinizde ürün bulunamadı'}/>
                )
            }
        </>
    )
}

const mapStateToProps = (state, ownProps) => ({
    rightBasketModal: state.BasketReducer.rightBasketModal,
    basketList: state.BasketReducer.basketList,
})

export default withRouter(connect(mapStateToProps)(BasketList));


